/** MixpanelEvents get triggered by the mixpanel.track(...) method provided by useMixpanel() */
export const MixpanelEvent = {
  AcceptRfqQuote: 'Accept RFQ quote',
  ActivateDeal: 'Activate deal',
  AddCardCancel: 'Add card cancel',
  AddCardFinish: 'Add card finish',
  AddCardStart: 'Add card start',
  AddCredential: 'Add credential',
  AddLayoutGroup: 'Add layout group',
  AddLayoutPanel: 'Add layout panel',
  AddMarketAccount: 'Add Market Account',
  AddMarketsTab: 'Add markets tab',
  AddMonitoringBlotterTab: 'Add monitoring blotter tab',
  AddNewSpace: 'Add new space',
  AddPriceGridPriceColumn: 'Add Price Grid Price Column',
  AddTab: 'Add tab',
  AddTreasuryLink: 'Add treasury link',
  AdjustBlotterHeight: 'Adjust blotter height',
  AllowSyntheticCounterCurrencyRequests: 'Allow synthetic counter currency requests',
  AllowSyntheticCrosses: 'Allow synthetic crosses',
  AlwaysDisplayBestBidOffer: 'Always Display Best Bid/Offer',
  ApiOrdersToggle: 'Api orders toggle',
  ApplyDetailsToOrderComment: 'Apply details to Order comment',
  ApplyFilterBuilderFilter: 'Apply FilterBuilder filter',
  ArchiveOrder: 'Archive order',
  BackToMobilePage: 'Back to previous page',
  BlockedPopoutWindow: 'Blocked popout window',
  BookManualLoan: 'Book manual loan deal',
  BookManualOTCDeal: 'Book manual OTC deal',
  BookManualTrade: 'Book manual trade',
  BulkEditSymbol: 'Bulk Edit Symbol',
  CalculateMargin: 'Calculate Margin',
  CancelAdmin: 'Cancel (admin)',
  CancelAllOrders: 'Cancel all orders',
  CancelBulkOrderSubmission: 'Cancel bulk order submission',
  CancelCustomerQuote: 'Cancel customer quote',
  CancelForce: 'Cancel (force)',
  CancelNewCustomerTrade: 'Cancel new customer trade',
  CancelOrder: 'Cancel order',
  CancelRfq: 'Cancel RFQ',
  CancelSpacesNavRearrange: 'Cancel spaces nav rearrange',
  ChangeAllocations: 'Change allocations',
  ChangeAllowedSlippage: 'Change allowed slippage',
  ChangeAnalyticsTab: 'Change analytics tab',
  ChangeAnnotations: 'Change annotations',
  ChangeBlotterColumns: 'Change blotter columns',
  ChangeCardSlide: 'Change card slide',
  ChangeChartType: 'Change chart type',
  ChangeCredentialsTab: 'Change credentials tab',
  ChangeDateRange: 'Change date range',
  ChangeDisplayMode: 'Change display mode',
  ChangeHomeCurrency: 'Change Home currency',
  ChangeLadderIncrement: 'Change ladder increment',
  ChangeLadderResolution: 'Change ladder resolution',
  ChangeLayout: 'Change layout',
  ChangeMarketAccount: 'Change market account',
  ChangeMarketDistributionTab: 'Change market distribution tab',
  ChangeMarketTab: 'Change market tab',
  ChangeMonitoringBlotterEntity: 'Change monitoring blotter entity',
  ChangeOrderCurrency: 'Change Order currency',
  ChangeOrderDetailsTab: 'Change order details tab',
  ChangeOrderFormSymbol: 'Change order form symbol',
  ChangeOrderFormTab: 'Change order form tab',
  ChangeOrderGroup: 'Change order group',
  ChangeOrderMarketAccounts: 'Change order market accounts',
  ChangeOrderPreset: 'Change order preset',
  ChangeOrderPrice: 'Change order price',
  ChangeOrderSide: 'Change order side',
  ChangeOrderStrategy: 'Change order strategy',
  ChangePayoutChartValues: 'Change payout chart values',
  ChangePreTradeTabHistory: 'Change Pre Trade tab - History',
  ChangePreTradeTabScenarioDetails: 'Change Pre Trade tab - Scenario Details',
  ChangePriceBucketing: 'Change price bucketing',
  ChangePriceGridLadderIncrement: 'Change Price Grid Ladder Increment',
  ChangeQuantityToggle: 'Change quantity toggle',
  ChangeRate: 'Change rate',
  ChangeReportMarket: 'Change report market',
  ChangeReportMonth: 'Change report month',
  ChangeReportSizeBucket: 'Change report size bucket',
  ChangeReportStrategy: 'Change report strategy',
  ChangeReportSymbol: 'Change report symbol',
  ChangeReportType: 'Change report type',
  ChangeRfqCurrency: 'Change RFQ currency',
  ChangeRfqGroup: 'Change RFQ group',
  ChangeRfqMarketAccounts: 'Change RFQ market accounts',
  ChangeRfqSide: 'Change RFQ side',
  ChangeRfqSymbol: 'Change RFQ symbol',
  ChangeSettlementPerspective: 'Change settlement perspective',
  ChangeSettlementTime: 'Change settlement time',
  ChangeSidebarPin: 'Change sidebar pin',
  ChangeSizeBuckets: 'Change size buckets',
  ChangeSubAccount: 'Change subAccount',
  ChangeSymbol: 'Change symbol',
  ChangeThemeType: 'Change theme type',
  ChangeTimeFilter: 'Change time filter',
  ChangeTimelineFilter: 'Change timeline filter',
  ChangeTopOfBookSize: 'Change Top of Book size',
  ClearAllNotifications: 'Clear all notifications',
  ClearAllOrders: 'Clear all orders',
  ClearCard: 'Clear card',
  ClearCustomRate: 'Clear custom rate',
  ClearDefaultAggregation: 'Clear default aggregation',
  ClickCreateHedgeRule: 'Click create hedge rule',
  ClickCreateNewAutohedgingRule: 'Click create new autohedging rule',
  ClickedNotification: 'Clicked notification',
  ClickFeatureShowcaseStep: 'Click feature showcase step',
  ClickGlobalAutoHedgingActionButton: 'Click global AutoHedging action button',
  ClickHeaderAutoHedgingButton: 'Click header AutoHedging button',
  ClickLadderRow: 'Click ladder row',
  ClickOpenFilterBuilderButton: 'Click open FilterBuilder button',
  ClickReportLegend: 'Click report legend',
  ClickShowAllMarketAccounts: 'Click Show All market accounts',
  ClickShowSelectedMarketAccounts: 'Click Show Selected market accounts',
  ClickUpdateHedgeRule: 'Click update hedge rule',
  CloneMultileg: 'Clone multileg',
  CloneSubAccount: 'Clone Sub Account',
  CloneTab: 'Clone tab',
  CloseCardSettings: 'Close card settings',
  CloseFeatureShowcase: 'Close feature showcase',
  CloseLayoutPopout: 'Close layout popout',
  CloseMarketTabSettings: 'Close market tab settings',
  ClosePopout: 'Close popout',
  ClosePosition: 'Close position',
  CloseRfqForm: 'Close RFQ form',
  CloseTab: 'Close tab',
  CollapseAllRows: 'Collapse all rows',
  CompleteFeatureShowcase: 'Complete feature showcase',
  ConfirmGlobalAutohedgingCommand: 'Confirm Global Autohedging Command',
  ContinueToDesktopVersion: 'Continue to desktop version',
  CopyCell: 'Copy cell',
  CopyDetails: 'Copy details',
  CopyJSON: 'Copy JSON',
  CopyRowAsCSV: 'Copy row as CSV',
  CopyRowAsJSON: 'Copy row as JSON',
  CopyRowsInGroupAsCSV: 'Copy rows in group as CSV',
  CopyRowsInGroupAsJSON: 'Copy rows in group as JSON',
  CopyURL: 'Copy URL',
  CreateCustomerTrade: 'Create customer trade',
  CreateMarketCard: 'Create market card',
  CreateNewLayoutTemplate: 'Create new layout template',
  CreateNewLoan: 'Create New Loan',
  CreateNewMultileg: 'CreateNewMultileg',
  CreateNewOTC: 'Create New OTC',
  CreateNewRepo: 'Create New Repo',
  CreatePassChangeUrl: 'Create Pass Change Url',
  CreateSubAccountClick: 'Create Sub Account Click',
  CreateTempAccountLedgerEventsDetailsTab: 'Create Temporary Account Ledger Events Details Tab',
  CreateTempReconMismatchDetailsTab: 'Create Temporary Recon Mismatch Details Tab',
  CustomerBlotterColumns: 'Customer blotter columns',
  CustomerPCApplyTotal: 'Customer Pricing Calculator Apply Total',
  CustomerPCCopyDetails: 'Customer Pricing Calculator Copy Details',
  CustomerPCLockCustomerPrice: 'Customer Pricing Calculator Lock Customer Price',
  CustomerPCResetConversionRate: 'Customer Pricing Calculator Reset Conversion Rate',
  CustomerPricingCalculatorInOrderForm: 'Customer Pricing Calculator in the Order Form',
  CustomerPricingCalculatorStartsExpanded: 'Customer Pricing Calculator starts expanded',
  DefaultMarketAccount: 'Default Market Account',
  DefaultMultilegStrategy: 'Default Multileg Strategy',
  DefaultStrategy: 'Default strategy',
  DefaultToEmptyOrderMarkets: 'Default to empty order markets',
  DeleteCard: 'Delete card',
  DeleteLayoutTemplate: 'Delete layout template',
  DeleteReport: 'Delete report',
  DisableEquityMarginRatioLimit: 'Disable Equity Margin Ratio Limit',
  DisableTradingMarketAccount: 'Disable Trading - Market Account',
  DismissAllTours: 'Dismiss All Tours',
  DismissTour: 'Dismiss Tour',
  DisplayUpToChildLevel: 'Display up to child level',
  DisplayUpToThisLevel: 'Display up to this level',
  DragAndDropGrouping: 'Drag and Drop Grouping',
  DuplicateTab: 'Duplicate tab',
  DynamicDeltaHedgingOrdersHidden: 'Dynamic Delta Hedging Orders Hidden',
  DynamicDeltaHedgingOrdersShown: 'Dynamic Delta Hedging Orders Shown',
  EditBulkClosePositionSymbol: 'Edit Bulk Close Position Symbol',
  EditMultileg: 'Edit multileg',
  EditSymbol: 'Edit Symbol',
  EditUser: 'Edit user',
  EnableAdvancedOrderDetails: 'Enable Advanced Order Details',
  EnableBBOForPriceOffsets: 'Enable Price Offset Use Best Bid Offer',
  EnableCheckLimitPriceReasonability: 'Enable Check limit price reasonability',
  EnableClickToTrade: 'Enable Click to trade',
  EnableConfirmOrderCancels: 'Enable Confirm order cancels',
  EnableConfirmOrderResume: 'Enable Confirm order resume',
  EnableDefaultingDerivativeQuantityToContracts: 'Enable defaulting initial derivative quantity in Contract terms',
  EnableDefaultMarketCardSubAccount: 'Enable Default Sub Account per market card',
  EnableDefaultNewOrderToCounterCurrency: 'Enable default new order/RFQ to counter currency',
  EnableEquityMarginRatioLimit: 'Enable Equity Margin Ratio Limit',
  EnableFlexibleLayout: 'Enable flexible layout',
  EnableKeepFormOpenAfterSubmit: 'Enable keep form open after submit',
  EnableOldOrderForm: 'Use legacy order form',
  EnableOrderFilledSound: 'Enable Order filled sound',
  EnableReduceFirstByDefaultDisabled: 'Enable Reduce First by Default Disabled',
  EnableReduceFirstByDefaultEnabled: 'Enable Reduce First by Default Enabled',
  EnableReduceOnlyByDefaultDisabled: 'Enable Reduce Only by Default Disabled',
  EnableReduceOnlyByDefaultEnabled: 'Enable Reduce Only by Default Enabled',
  EnableTotalCostOnHover: 'Enable Total cost on hover',
  EnableTradingMarketAccount: 'Enable Trading - Market Account',
  ExclusivelyPrimePriceOnRePriming: 'Do not prime qty when re-priming rate in New Order',
  ExitConfirmGlobalAutohedgingCommand: 'Exit Confirm Global Autohedging Command',
  ExpandAllRows: 'Expand All Rows',
  ExpandBlotter: 'Expand blotter',
  ExpandMarketCardContractDetails: 'Expand market card contract details',
  ExpandRow: 'Expand row',
  Export: 'Export',
  ExportBalances: 'Export balances',
  ExportCredit: 'Export credit',
  ExportDatesUTC: 'Export dates UTC',
  ExportFundingEvents: 'Export Funding Events',
  ExportMargin: 'Export Margin',
  ExportOpenOrders: 'Export Open Orders',
  ExportOrders: 'Export orders',
  ExportPositions: 'Export Positions',
  ExportReport: 'Export report',
  ExportRows: 'Export rows',
  ExportRowsModalOpen: 'Export rows modal open',
  ExportRowsToExcel: 'Export rows (to Excel)',
  ExportSettlementReport: 'Export settlement report',
  ExportTrades: 'Export trades',
  ExportTransactions: 'Export transactions',
  FavoriteAggregation: 'Favorite Aggregation',
  FavoriteFilter: 'Favorite Filter',
  FavoriteOrderPreset: 'Favorite order preset',
  FavoriteStrategy: 'Favorite strategy',
  FavoriteSubAccount: 'Favorite Sub Account',
  FavoriteSymbol: 'Favorite symbol',
  FilterCell: 'Filter cell',
  FilterColumn: 'Filter column',
  FilterQuickSearch: 'Filter QuickSearch',
  FilterTimeTypeChanged: 'Filter time type changed',
  FilterTransferConfigRows: 'Filter transfer config rows',
  FilterWatchlist: 'Filter watchlist',
  FirstPriceBackOnRFQ: 'First price back on RFQ',
  FlipMultilegLegs: 'Flip multileg legs',
  ForceCancelCareOrder: 'Force cancel Care Order',
  ForceCancelOrder: 'Force cancel Order',
  ForceLogout: 'Force Logout',
  GenerateCustomerOrderSummary: 'Generate customer order summary',
  GroupAccounts: 'Group accounts',
  GroupAssets: 'Group assets',
  GroupCustomer: 'Group Customer',
  GroupExpiries: 'Group expiries',
  GroupingRemoved: 'Grouping removed',
  GroupProducts: 'Group products',
  GroupProductType: 'Group Product Type',
  GroupSubAccounts: 'Group sub accounts',
  GroupUnderlying: 'Group Underlying',
  HideBlotterColumn: 'Hide blotter column',
  HoverReportLegend: 'Hover report legend',
  HoverUnderlyingPrice: 'Hover underlying price',
  HoverWarningIcon: 'Hover warning icon',
  InitiateCustomerTransfer: 'Initiate customer transfer',
  InitiateMarketplaceTransfer: 'Initiate marketplace transfer',
  InitiatePrincipalTransfer: 'Initiate principal transfer',
  InviteNewUser: 'Invite new user',
  KillSwitch: 'Kill switch',
  /** @deprecated use OpenKnowledgeBase instead */
  KnowledgeBase: 'Knowledge base',
  LinkCustomerHedgeSubaccount: 'Link customer hedge subaccount',
  LoadApp: 'Load app',
  LogOut: 'Log out',
  LPSettlementBatchDetails: 'Opened LP settlement batch details',
  LPSettlementBookManualTransfer: 'Booked LP settlement outbound transfer manually',
  LPSettlementChangeMode: 'Saved LP settlement account mode',
  LPSettlementManualBatchCreated: 'LP settlement manual batch created in UI',
  LPSettlementInitiateTransfer: 'Submitted LP settlement outbound transfer',
  LPSettlementMarkTransferReceived: 'Marked LP settlement inbound received manually',
  LPSettlementUnbatch: 'Unbatched LP settlement batch in UI',
  ManageAggregations: 'Manage Aggregations',
  MarketSecurity: 'Market security',
  MarketSecurityEnableDisableDialogOpened: 'Market security enable/disable dialog opened',
  MarketTabClose: 'Market tab close',
  MarketTabDiscard: 'Market tab discard',
  MarketTabSave: 'Market tab save',
  MaximizeLayoutGroup: 'Maximize layout group',
  MinimizeBlotter: 'Minimize blotter',
  MinimizeLayoutGroup: 'Minimize layout group',
  ModifyAssetTransaction: 'Modify asset transaction',
  ModifyCustomerTrade: 'Modify customer trade',
  ModifyFixing: 'Modify fixing',
  ModifyManualTrade: 'Modify manual trade',
  ModifyOrder: 'Modify order',
  ModifyOrderGroup: 'Modify order group',
  ModifyOrders: 'Modify orders',
  ModifyOrphanTrade: 'Modify orphan trade',
  ModifySalesOrder: 'Modify sales order',
  ModifySubaccount: 'Modify Sub Account',
  MovedCard: 'Moved card',
  MovedLayoutPanel: 'Moved layout panel',
  MovedSpacesNavItem: 'Moved spaces nav item',
  NavigateTo: 'Navigate to',
  NavigateToAdminAllocationControls: 'Navigate to Admin Allocation Controls',
  NavigateToAdminConnectivityAddresses: 'Navigate to Admin Connectivity Addresses',
  NavigateToAdminConnectivityCounterparties: 'Navigate to Admin Connectivity Counterparties',
  NavigateToAdminConnectivityCredentials: 'Navigate to Admin Connectivity Credentials',
  NavigateToAdminConnectivityCreditSupportAnnexes: 'Navigate to Admin Connectivity Credit Support Annexes',
  NavigateToAdminConnectivityMarketAccounts: 'Navigate to Admin Connectivity Market Accounts',
  NavigateToAdminNotificationsDestinations: 'Navigate to Admin Notifications Destinations',
  NavigateToAdminNotificationsRuleManagement: 'Navigate to Admin Notifications Rule Management',
  NavigateToAdminSecurityMasterMultileg: 'Navigate to Admin Security Master Multileg',
  NavigateToAdminSecurityMasterSecurityMaster: 'Navigate to Admin Security Master Security Master',
  NavigateToAdminSubAccounts: 'Navigate to Admin Sub Accounts',
  NavigateToAdminTradingTradingAggregations: 'Navigate to Admin Trading Trading Aggregations',
  NavigateToAdminTradingTradingControls: 'Navigate to Admin Trading Trading Controls',
  NavigateToAdminTradingTradingLimits: 'Navigate to Admin Trading Trading Limits',
  NavigateToAdminTradingUnifiedLiquidity: 'Navigate to Admin Trading Unified Liquidity',
  NavigateToAdminUserGroups: 'Navigate to Admin User Groups',
  NavigateToAdminUsers: 'Navigate to Admin Users',
  NavigateToDealerAdminCustomerAccounts: 'Navigate to Dealer Admin Customer Accounts',
  NavigateToDealerAdminCustomerMargin: 'Navigate to Dealer Admin Customer Margin',
  NavigateToDealerAdminFIXConnections: 'Navigate to Dealer Admin FIX Connections',
  NavigateToDealerAdminTradingLimits: 'Navigate to Dealer Admin Trading Limits',
  NavigateToDealerAdminUsers: 'Navigate to Dealer Admin Users',
  NavigateToDealerAggregations: 'Navigate to Dealer Aggregations',
  NavigateToDealerBuyingPowerAddresses: 'Navigate to Dealer Buying Power Addresses',
  NavigateToDealerBuyingPowerBalances: 'Navigate to Dealer Buying Power Balances',
  NavigateToDealerBuyingPowerCredit: 'Navigate to Dealer Buying Power Credit',
  NavigateToDealerBuyingPowerCustomerSettlement: 'Navigate to Dealer Buying Power Customer Settlement',
  NavigateToDealerBuyingPowerTransfers: 'Navigate to Dealer Buying Power Transfers',
  NavigateToDealerConfigurations: 'Navigate to Dealer Configurations',
  NavigateToDealerExecutionRules: 'Navigate to Dealer Execution Rules', // Legacy
  NavigateToDealerMonitoring: 'Navigate to Dealer Monitoring',
  NavigateToDealerNetAcquisitionLimitMemberships: 'Navigate to Dealer Net Acquisition Limit Memberships',
  NavigateToDealerNetAcquisitionLimits: 'Navigate to Dealer Net Acquisition Limits',
  NavigateToDealerOrderAcceptanceRules: 'Navigate to Dealer Order Acceptance Rules',
  NavigateToDealerPricingRulesBeta: 'Navigate to Dealer Pricing Rules Beta',
  NavigateToDealerPricingRulesLegacy: 'Navigate to Dealer Pricing Rules Legacy',
  NavigateToDealerPricingTiers: 'Navigate to Dealer Pricing Tiers',
  NavigateToDealerRFQProtocolRules: 'Navigate to Dealer RFQ Protocol Rules',
  NavigateToDealerSecurityMaster: 'Navigate to Dealer Security Master',
  NavigateToDealerSubAccountMappings: 'Navigate to Dealer Sub Account Mappings',
  NavigateToDealerSymbolGroups: 'Navigate to Dealer Symbol Groups',
  NavigateToHedgeRulesTab: 'Navigate to Hedge Rules Tab',
  NavigateToOperationsComplianceApprovalsAndPolicies: 'Navigate to Operations Compliance Approvals & Policies',
  NavigateToOperationsComplianceUniverses: 'Navigate to Operations Compliance Universes',
  NavigateToOperationsOperationalRiskActions: 'Navigate to Operations Operational Risk Actions',
  NavigateToOperationsOperationalRiskCounterpartyMonitoring:
    'Navigate to Operations Operational Risk Counterparty Monitoring',
  NavigateToOperationsOperationalRiskReconciliation: 'Navigate to Operations Operational Risk Reconciliation',
  NavigateToOperationsTreasuryManagementLpSettlement: 'Navigate to Operations Treasury Management LP Settlement',
  NavigateToOperationsTreasuryManagementOperationalReports:
    'Navigate to Operations Treasury Management Operational Reports',
  NavigateToOperationsTreasuryManagementOverview: 'Navigate to Operations Treasury Management Overview',
  NavigateToOperationsTreasuryManagementTransactions: 'Navigate to Operations Treasury Management Transactions',
  NavigateToPortfolioDataManagementBenchmarks: 'Portfolio Data Management Benchmarks',
  NavigateToPortfolioDataManagementFactorModels: 'Portfolio Data Management Factor Models',
  NavigateToPortfolioDataManagementTimeSeries: 'Portfolio Data Management Time-Series',
  NavigateToPortfolioDataManagementUniverses: 'Portfolio Data Management Universes',
  NavigateToPortfolioEngineeringBackTester: 'Navigate to Portfolio Engineering Back-tester',
  NavigateToPortfolioEngineeringBenchmarks: 'Navigate to Portfolio Engineering Benchmarks',
  NavigateToPortfolioEngineeringCompliance: 'Navigate to Portfolio Engineering Compliance',
  NavigateToPortfolioEngineeringJobs: 'Navigate to Portfolio Engineering Jobs',
  NavigateToPortfolioEngineeringModels: 'Navigate to Portfolio Engineering Models',
  NavigateToPortfolioEngineeringPermissions: 'Navigate to Portfolio Engineering Permissions',
  NavigateToPortfolioEngineeringRebalance: 'Navigate to Portfolio Engineering Rebalance',
  NavigateToPortfolioEngineeringReporting: 'Navigate to Portfolio Engineering Reporting',
  NavigateToPortfolioEngineeringRiskModels: 'Navigate to Portfolio Engineering Risk Models',
  NavigateToPortfolioEngineeringTimeSeries: 'Navigate to Portfolio Engineering Time-Series',
  NavigateToPortfolioEngineeringUniverses: 'Navigate to Portfolio Engineering Universes',
  NavigateToPortfolioLpSettlement: 'Navigate to Portfolio LP Settlement',
  NavigateToPortfolioLpSettlementActiveBatches: 'Navigate to Portfolio LP Settlement Active Batches',
  NavigateToPortfolioLpSettlementBatchHistory: 'Navigate to Portfolio LP Settlement Batch History',
  NavigateToPortfolioLpSettlementUnsettledTransactions: 'Navigate to Portfolio LP Settlement Unsettled Transactions',
  NavigateToPortfolioManagementMargin: 'Portfolio Management Margin',
  NavigateToPortfolioManagementOverview: 'Portfolio Management Overview',
  NavigateToPortfolioManagementPerformance: 'Portfolio Management Performance',
  NavigateToPortfolioManagementReports: 'Portfolio Management Reports',
  NavigateToPortfolioManagementTransactions: 'Portfolio Management Transactions',
  NavigateToPortfolioOperationsOverview: 'Portfolio Operations Overview',
  NavigateToPortfolioOperationsReconciliation: 'Portfolio Operations Reconciliation',
  NavigateToPortfolioOperationsReports: 'Portfolio Operations Reports',
  NavigateToPortfolioOperationsSettlement: 'Portfolio Operations Settlement',
  NavigateToPortfolioOperationsTransactions: 'Portfolio Operations Transactions',
  NavigateToPortfolioPortfolioConstructionAttribution: 'Portfolio Portfolio Construction Attribution',
  NavigateToPortfolioPortfolioConstructionModels: 'Portfolio Portfolio Construction Models',
  NavigateToPortfolioPortfolioConstructionRebalance: 'Portfolio Portfolio Construction Rebalance',
  NavigateToPortfolioPositionsMargin: 'Portfolio Positions Margin',
  NavigateToPortfolioPositionsOverview: 'Portfolio Positions Overview',
  NavigateToPortfolioPositionsPerformance: 'Portfolio Positions Performance',
  NavigateToPortfolioPositionsReports: 'Portfolio Positions Reports',
  NavigateToPortfolioPositionsTransactions: 'Portfolio Positions Transactions',
  NavigateToPortfolioRiskExposures: 'Portfolio Risk Exposures',
  NavigateToPortfolioRiskReports: 'Portfolio Risk Reports',
  NavigateToResearchDataManagementBenchmarks: 'Navigate to Research Data Management Benchmarks',
  NavigateToResearchDataManagementFactorModels: 'Navigate to Research Data Management Factor Models',
  NavigateToResearchDataManagementTimeSeries: 'Navigate to Research Data Management Time-Series',
  NavigateToResearchDataManagementUniverses: 'Navigate to Research Data Management Universes',
  NavigateToResearchToolsBackTester: 'Navigate to Research Tools Back-Tester',
  NavigateToResearchToolsModels: 'Navigate to Research Tools Models',
  NavigateToSettingsUserSettingsAPIKey: 'Navigate to Settings User Settings API Key',
  NavigateToSettingsUserSettingsGeneral: 'Navigate to Settings User Settings General',
  NavigateToSettingsUserSettingsTrading: 'Navigate to Settings User Settings Trading',
  NavigateToSettingsUserSettingsUserNotifications: 'Navigate to Settings User Settings User Notifications',
  NavigateToTalosAdminConfigurations: 'Navigate to Talos Admin Configurations',
  NavigateToTalosAdminCurrencies: 'Navigate to Talos Admin Currencies',
  NavigateToTalosAdminEntityAdminLoadTesting: 'Navigate to Talos Admin EntityAdmin Load Testing',
  NavigateToTalosAdminEntityAdminWorkflows: 'Navigate to Talos Admin EntityAdmin Workflows',
  NavigateToTalosAdminFIXConnections: 'Navigate to Talos Admin FIX Connections',
  NavigateToTalosAdminMarketAccountsDeprecated: 'Navigate to Talos Admin Market Accounts Deprecated',
  NavigateToTalosAdminMarketConnections: 'Navigate to Talos Admin Market Connections',
  NavigateToTalosAdminOrderStrategies: 'Navigate to Talos Admin Order Strategies',
  NavigateToTalosAdminOrganizations: 'Navigate to Talos Admin Organizations',
  NavigateToTalosAdminOrganizationsDeprecated: 'Navigate to Talos Admin Organizations Deprecated',
  NavigateToTalosAdminProcesses: 'Navigate to Talos Admin Processes',
  NavigateToTalosAdminProductTemplates: 'Navigate to Talos Admin Product Templates',
  NavigateToTalosAdminSecurities: 'Navigate to Talos Admin Securities',
  NavigateToTalosAdminUsers: 'Navigate to Talos Admin Users',
  NavigateToWhatsNew: 'Navigate to Whats new',
  NegotiateLoanQuoteRequest: 'Negotiate loan quote request',
  NewMultilegDefaultDelta1Behaviour: 'New Multileg Default Delta-1 Behaviour',
  NewQuoteUpdatedQuoteOnRFQ: 'New quote/updated quote on RFQ',
  NewUser: 'New user',
  NextFeatureShowcaseStep: 'Next feature showcase step',
  NextTourStep: 'Next tour step',
  NotificationsOpenUserSettings: 'Open Notifications User Settings',
  OffPlatformTradesToggle: 'Off platform trades toggle',
  OpenAddNewSpaceModal: 'Open add new space modal',
  OpenAutoHedgePositionRuleDrawer: 'Open Auto Hedge Position Rule Drawer',
  OpenAvaAI: 'Open Ava AI',
  OpenCardSettings: 'Open card settings',
  OpenCreateTemplateModal: 'Open create template modal',
  OpenCredentials: 'Open credentials',
  OpenCustomerOrderContext: 'Open customer order context',
  OpenDeepDive: 'Open DeepDive',
  OpenEditSpaceModal: 'Open edit space modal',
  OpenEditTemplateModal: 'Open edit template modal',
  OpenFeatureShowcase: 'Open feature showcase',
  OpenKnowledgeBase: 'Open Knowledge Base',
  OpenLayoutMenu: 'Open layout menu',
  OpenLedgerEventsModal: 'Open ledger events modal',
  OpenManualFillForm: 'Open manual fill form',
  OpenManualPricingForm: 'Open manual pricing form',
  OpenManualTradeForm: 'Open manual trade form',
  OpenMarketSelectorFromMarketCardButton: 'Open Market Selector from Market Card Button',
  OpenMarketSelectorFromMarketCardMenu: 'Open Market Selector from Market Card Menu',
  OpenMarketSelectorFromMarketCardSettings: 'Open Market Selector from Market Card Settings',
  OpenMobileTabBarOverflow: 'Open mobile tab bar overflow',
  OpenModifyCustomerTrade: 'Open modify customer trade',
  OpenModifyOrder: 'Open modify order',
  OpenMultilegDeepDive: 'OpenMultilegDeepDive',
  OpenMultilegLegMarketSelector: 'Open multileg leg market selector',
  OpenNewCustomerTrade: 'Open new customer trade',
  OpenOMSPopout: 'Open oms popout',
  OpenOptionsChain: 'Open Options Chain',
  OpenOptionsColumnsSelector: 'Open options columns selector',
  OpenOrderAnalytics: 'Open order analytics',
  OpenOrderDetails: 'Open order details',
  OpenOrderForm: 'Open order form',
  OpenOrderImportForm: 'Open order import form',
  OpenOrderPresetDialog: 'Open order preset dialog',
  OpenPowerSearch: 'Open power search',
  OpenReconMismatchResolutionDrawer: 'Open Recon Mismatch Resolution Drawer',
  OpenReport: 'Open report',
  OpenReportTab: 'Open report tab',
  OpenResubmitOrder: 'Open resubmit order',
  OpenResubmitRemaining: 'Open resubmit remaining',
  OpenResubmitRfq: 'Open resubmit RFQ',
  OpenRfqForm: 'Open RFQ form',
  OpenSalesOrderForm: 'Open sales order form',
  OpenSalesRfqForm: 'Open Sales RFQ form',
  OpenSession: 'Open Session',
  OpenSupportModal: 'Open Support Modal',
  OpenSymbolMenu: 'Open symbol menu',
  OpenSymbolSelectorFromMarketCard: 'Open Symbol Selector from Market Card',
  OpenTabMenu: 'Open tab menu',
  OpenTradingControlsSettings: 'Open Trading Controls Settings',
  OpenUpdateBalancesModal: 'Open update balances modal',
  OptionToBookCustomerTrade: 'option to Book Customer Trade',
  OrderArchivedSound: 'Order archived sound',
  OrderCanceledSound: 'Order canceled sound',
  OrderGroups: 'Order groups',
  OrderRejectedSound: 'Order rejected sound',
  PageTranslated: 'Page translated',
  PauseAllOrders: 'Pause all orders',
  PauseOrder: 'Pause order',
  PinAllSections: 'Pin all sections',
  PlaceCard: 'Place card',
  PMSPortfolioOverviewToggleChartBy: 'PMS: Toggle Portfolio Overview Chart By',
  PMSPortfolioOverviewToggleChartField: 'PMS: Toggle Portfolio Overview Chart Field',
  PMSPortfolioOverviewToggleTopN: 'PMS: Toggle Portfolio Overview Top N',
  PMSPortfolioPerformanceToggleTopN: 'PMS: Toggle Portfolio Performance Top N',
  PMSPortfolioRiskInspectorOpen: 'PMS: Open Portfolio Risk Inspector',
  PMSPortfolioRiskInspectorUpdated: 'PMS: Update Portfolio Risk Inspector',
  PMSTreatStablecoinsAsCash: 'PMS: Treat Stablecoins as Cash',
  PopoutLayoutGroup: 'Popout layout group',
  PopoutLayoutPanel: 'Popout layout panel',
  PreTrade: 'Pre Trade',
  PreTradeNotify: 'Pre Trade Notify',
  PreviewSalesOrder: 'Preview sales order',
  PreviousFeatureShowcaseStep: 'Previous feature showcase step',
  PrevTourStep: 'Prev tour step',
  PriceOffsetBid: 'Price Offset Bid',
  PriceOffsetBPS: 'Price Offset BPS',
  PriceOffsetBPSBehaviourIncrement: 'Price Offset BPS Behaviour Increment',
  PriceOffsetBPSBehaviourReset: 'Price Offset BPS Behaviour Reset',
  PriceOffsetOffer: 'Price Offset Offer',
  PrimeOrder: 'Prime order',
  PrimeRfq: 'Prime RFQ',
  PrimeSymbolSelector: 'Prime order with symbol from search dropdown',
  PublishCustomRate: 'Publish custom rate',
  RaisePaginationLimit: 'Raise pagination limit',
  RedoLayoutChange: 'Redo layout change',
  ReenableMobileUI: 'Reenable mobile UI',
  ReImportTabsForFlexibleLayout: 'Re-import tabs for flexible layout',
  ReloadLayout: 'Reload layout',
  RemoveBulkClosePositionRow: 'Remove Bulk Close Position Row',
  RemoveLayoutGroup: 'Remove layout group',
  RemoveLayoutPanel: 'Remove layout panel',
  RemoveReportTab: 'Remove report tab',
  RemoveSpace: 'Remove space',
  RemoveTradeFromBatch: 'Remove trade from batch',
  RemoveUser: 'Remove User',
  RenameTab: 'Rename tab',
  ReorderMobileTabBarItems: 'Reorder mobile tab bar items',
  ReorderTab: 'Reorder tab',
  ResetAppConfig: 'Reset app config',
  ResetBlotterColumns: 'Reset blotter columns',
  ResetColumns: 'Reset columns',
  ResetLayout: 'Reset layout',
  ResetLayoutAndTabs: 'Reset layout and tabs',
  ResolveReconMismatches: 'Resolve Recon Mismatches',
  ResumeAllOrders: 'Resume all orders',
  ResumeOrder: 'Resume order',
  SalesWorkflow: 'Sales workflow',
  SaveAsTab: 'Save as Tab',
  SaveMarketTabSettings: 'Save market tab settings',
  SaveMultilegLegMarkets: 'Save multileg leg markets',
  SaveNewLayout: 'Save new layout',
  SaveOrderPreset: 'Save order preset',
  SaveOrUpdateReport: 'Save or update report',
  SaveSpacesNavRearrange: 'Save spaces nav rearrange',
  SaveTemporaryPanel: 'Save temporary panel',
  SearchForAggregation: 'Search For Aggregation',
  SearchMarketsTab: 'Search markets tab',
  SelectAggregation: 'Select Aggregation',
  SelectAllColumns: 'Select all columns',
  SelectAllRows: 'Select all rows',
  SelectFutureForm: 'Select future order form',
  SelectLayoutTemplate: 'Select layout template',
  SelectMultilegForm: 'Select multileg order form',
  SelectOptionForm: 'Select option order form',
  SelectOrderPreset: 'Select order preset',
  SelectPerpForm: 'Select perp order form',
  SelectSpotForm: 'Select spot order form',
  SelectSubAccount: 'Select Sub Account',
  SendBulkClosePositionOrders: 'Send bulk close position orders',
  SendBulkOrder: 'Send bulk order',
  SendOrder: 'Send order',
  SendPasswordResetEmail: 'Send Password Reset Email',
  SendRfq: 'Send RFQ',
  SetBlotterTab: 'Set blotter tab',
  SetDefaultAggregation: 'Set default aggregation',
  SetDefaultSubAccount: 'Set default sub account',
  SetMarketCardTitle: 'Set market card title',
  SetMarketCardUnifiedLiquidity: 'Set market card unified liquidity',
  SetMarketCardView: 'Set market card view',
  SetPositionBlotterTab: 'Set position blotter tab',
  SettlementInitiated: 'Settlement initiated',
  SetTransfersBlotterTab: 'Set transfers blotter tab',
  SetUILocale: 'Set UI Locale',
  ShowAllDecimals: 'Show all decimals',
  ShowAllDecimalsInBlotters: 'Show All Decimals across all system blotters',
  ShowArchiveOrdersToggle: 'Show archive orders toggle',
  ShowBlotterColumn: 'Show blotter column',
  ShowDetails: 'Show Details',
  ShowExpandedDetails: 'Show expanded details',
  ShowFailedCancelOrderModal: 'Show failed cancel order modal',
  ShowGuide: 'Show Guide',
  ShowJSON: 'Show JSON',
  ShowPortfolioManagementSystem: 'Show Portfolio Management System',
  ShowWebAppInstallPrompt: 'Show web app install prompt',
  SimulateTradeScenarios: 'Simulate Trade Scenarios',
  SimulateTradeScenariosNotify: 'Simulate Trade Scenarios Notify',
  SortMarketsTab: 'Sort markets tab',
  SoundEffects: 'Sound effects',
  StagedOrder: 'Staged order',
  StartSpacesNavRearrange: 'Start spaces nav rearrange',
  Support: 'Support',
  SupportTicket: 'Support Ticket',
  TalosAdminConfigChanged: 'Talos Admin config changed',
  ToggleActiveOrders: 'Toggle active orders card',
  ToggleAdvancedMode: 'Toggle Advanced Mode',
  ToggleAlwaysDisplayMarketCardBestBidOffer: 'Toggle Always Display Market Card Best Bid/Offer',
  ToggleBPSInNewOrder: 'Toggle BPS in New Order',
  ToggleCashInNewOrder: 'Toggle Cash in New Order',
  ToggleCompactMobileCards: 'Toggle compact mobile cards',
  ToggleCredentialsOnly: 'Toggle credentials only',
  ToggleDefaultNewMarketCardsCompact: 'Toggle Default New Market Cards Compact',
  ToggleDelta1BPS: 'Toggle Delta-1 BPS',
  ToggleDetailsCard: 'Toggle details card',
  ToggleFees: 'Toggle Fees',
  ToggleFirmLiquidity: 'Toggle firm liquidity',
  ToggleForceCompactMarketCards: 'Toggle force compact market cards',
  ToggleIncludeCash: 'Toggle include cash',
  ToggleMarketCredentialsSearch: 'Toggle market credentials search',
  ToggleMarketCredentialsSortDirection: 'Toggle market credentials sort direction',
  ToggleMarketCredentialsSortMode: 'Toggle market credentials sort mode',
  ToggleMarkets: 'Toggle markets',
  TogglePriceGridAlignPricesOnDecimal: 'Toggle Price Grid Align Prices on Decimal',
  TogglePriceGridBestBidOfferHighlighting: 'Toggle Price Grid Best Bid/Offer Highlighting',
  TogglePriceGridLadderToPrice: 'Toggle Price Grid Ladder to Price',
  TogglePriceGridLadderToVolume: 'Toggle Price Grid Ladder to Volume',
  ToggleQuickSearch: 'Toggle quick search',
  ToggleReportInsights: 'Toggle report insights',
  ToggleReportSummary: 'Toggle report summary',
  ToggleShowActionRequiredOnly: 'Toggle show action required only',
  ToggleShowDisabled: 'Toggle Show Disabled',
  ToggleShowNotificationsInbox: 'Toggle show notifications inbox',
  ToggleShowReviewTransfer: 'Toggle show review transfer',
  ToggleShowTotals: 'Toggle ShowTotals',
  ToggleShowZeroBalances: 'Toggle ShowZeroBalances',
  ToggleSidebarLabels: 'Toggle sidebar labels',
  ToggleSubAccountPositionsBlotterHierarchical: 'Toggle Sub Account Positions Blotter Hierarchical',
  ToggleTransfersDrawer: 'Toggle Transfers Drawer',
  ToggleULSymbols: 'Toggle UL Symbols',
  ToggleUnifiedLiquidity: 'Toggle unified liquidity',
  ToggleWatchlist: 'Toggle watchlist',
  TotalPresetsCount: 'Total Presets',
  TotalPresetsWithAggregationCount: 'Total Presets with Aggregations',
  TradingControlsDisableCustomerTrading: 'Disable Customer Trading',
  TradingControlsDisableDDHTrading: 'Disable Dynamic Delta Hedging Trading',
  TradingControlsDisablePositionAutoHedging: 'Disable Position Auto-Hedging',
  TradingControlsDisableTrading: 'Disable Trading',
  TradingControlsEnableCustomerTrading: 'Enable Customer Trading',
  TradingControlsEnableDDHTrading: 'Enable Dynamic Delta Hedging Trading',
  TradingControlsEnablePositionAutoHedging: 'Enable Position Auto-Hedging',
  TradingControlsEnableTrading: 'Enable Trading',
  TradingControlsOpenDialog: 'Open Trading Controls Modal',
  TradingControlsOpenMarketAccounts: 'Open Market Account Trading Controls',
  TreasuryDoughnutSliceClicked: 'Treasury doughnut slice clicked',
  UnarchiveOrder: 'Unarchive order',
  UndoLayoutChange: 'Undo layout change',
  UnselectMarketAccount: 'Unselect Market Account',
  UpdateBalances: 'Updates balance',
  UpdateColumns: 'Update columns',
  UpdateCredential: 'Update credential',
  UpdateCustomerQuote: 'Update customer quote',
  UpdateLayoutTemplate: 'Update layout template',
  UpdateMarketAccount: 'Update market account',
  UpdateMarketCard: 'Update market card',
  UpdateMarketSelection: 'Update market selection',
  UpdateOptionFilter: 'Update option filter',
  UpdateOptionStrike: 'Update option strike',
  UpdateOrder: 'Update order',
  UpdateOrderPreset: 'Update order preset',
  UpdateSpace: 'Update space',
  UpdateTransferConfigRow: 'Update transfer config row',
  UploadFileForOrderImport: 'Upload file for order import',
  UseScenario: 'Use Scenario',
  ViewAllDDHOrders: 'View All DDH Orders',
  ViewAllExpiries: 'View All Expiries',
  ViewAllOrderBooks: 'View All Order Books',
  ViewAnalyticsTooltip: 'View Analytics Tooltip',
  ViewCredential: 'View Credential',
  ViewDeepDive: 'View DeepDive',
  ViewDynamicDeltaHedgingTooltip: 'View Dynamic Delta Hedging Tooltip',
  ViewFullAnalytics: 'View Full Analytics',
  ViewMarketDistributionTooltip: 'View Market Distribution Tooltip',
  ViewMarketsTabSettings: 'View markets tab settings',
  ViewMktsTooltip: 'View Mkts tooltip',
  ViewMobileUnsupportedSection: 'View mobile unsupported section',
  ViewOpenMarketOrder: 'View open market order',
  ViewParamsTooltip: 'View params tooltip',
  ViewParentOrderDetails: 'View Parent Order Details',
  ViewPriceGridAlignPricesOnDecimalState: 'View Price Grid Align Prices on Decimal State',
  ViewPriceGridLadderState: 'View Price Grid Ladder State',
  ViewReportTooltip: 'View report tooltip',
  ViewSection: 'View section',
  ViewSingleExpiry: 'View Single Expiry',
  ViewStrategyTooltip: 'View strategy tooltip',
  ViewTimelineDiff: 'View timeline diff',
  ViewTimelineJSON: 'View timeline JSON',
  ViewTooltip: 'View Tooltip',
  ViewTradeHistory: 'View trade history',
  ViewTradingControl: 'View Trading Control',
  ViewTradingControlDefaultSettings: 'View Default Settings',
  WebAppDismissed: 'Web app dismissed',
  WebAppInstalled: 'Web app installed',
  // Keep values sorted
} as const;
export type MixpanelEvent = (typeof MixpanelEvent)[keyof typeof MixpanelEvent];

export const MixpanelMetadata = {
  AllowedSlippage: 'Allowed slippage',
  AlwaysDisplayBestBidOffer: 'Always Display Best Bid/Offer',
  BlankMarketAccountsWhenOpeningOrderForm: 'Blank Market Accounts when opening the Order Form',
  BlotterTabCounts: 'Blotter Tab Counts',
  DefaultNewOrderToCounterCurrency: 'Default new order/RFQ to counter currency',
  Delta1BPS: 'Delta-1 BPS',
  DisplayMode: 'Display mode',
  EnableClickToTrade: 'Enable click-to-trade',
  EnableOrderGroups: 'Enable order groups',
  EnableSyntheticCurrency: 'Enable synthetic counter ccy',
  EnableNewMarketAccountSelector: 'Enable New Market Account Selector',
  Environment: 'Environment',
  FirmLiquidity: 'Firm Liquidity',
  LastSeen: 'Last seen',
  Locale: 'Locale',
  MaxCardColumns: 'Max card columns',
  MaxCardRows: 'Max card rows',
  MaxCards: 'Max cards',
  MobileUI: 'Mobile UI',
  NumberOfCardsWithAggregationSet: 'Number of cards with aggregation set',
  NumberOfCardsWithCompactView: 'Number of cards with compact view',
  NumberOfCardsWithExpandedView: 'Number of cards with expanded view',
  NumberOfCardsWithMarketsList: 'Number of cards with markets list',
  NumberOfCardsWithMiniChart: 'Number of cards with mini chart',
  NumberOfCardsWithPreset: 'Number of cards with Order Preset',
  NumberOfCardsWithPriceLadder: 'Number of cards with price ladder',
  NumberOfCardsWithVolumeLadder: 'Number of cards with volume ladder',
  NumberOfDefaultMarketAccounts: 'Number of Default Market Accounts',
  NumberOfFavoriteAggregations: 'Number of Favorite Aggregations',
  HasDefaultAggregation: 'Has Default Aggregation',
  NumberOfFavoriteEventSeries: 'Number of Favorite Event Series',
  NumberOfFavoriteEvents: 'Number of Favorite Events',
  NumberOfFavoriteSymbols: 'Number of Favorite Symbols',
  NumberOfOMSPopouts: 'Number of oms popouts',
  NumberOfOpenDeepDiveTabs: 'Number of Open DeepDive Tabs',
  NumberOfOpenMarketCards: 'Number of open Market Cards',
  NumberOfOpenMarketTabs: 'Number of open Markets Tabs',
  NumberOfOpenOptionTabs: 'Number of open Option Tabs',
  NumberOfOpenOrderDetailsTabs: 'Number of Open OrderDetails Tabs',
  NumberOfPredictionMarketCardsForAllOutcomes: 'Number of Prediction Market Cards for all Outcomes',
  NumberOfPredictionMarketCardsForOutcome: 'Number of Prediction Market Cards for an Outcome',
  NumberOfOrderPresets: 'Number of Order Presets',
  NumberOfDefaultTemplatesForAllUsers: 'Number of default templates for all users',
  NumberOfDefaultTemplatesForNewUsers: 'Number of default templates for new users',
  NumberOfIntelSpaces: 'Number of intel spaces',
  NumberOfMonitoringSpaces: 'Number of monitoring spaces',
  NumberOfSpaces: 'Number of spaces',
  NumberOfSpacesAllDevices: 'Number of all-device spaces',
  NumberOfSpacesDesktop: 'Number of desktop spaces',
  NumberOfSpacesLaptop: 'Number of laptop spaces',
  NumberOfSpacesMobile: 'Number of mobile spaces',
  NumberOfSpacesTablet: 'Number of tablet spaces',
  NumberOfSpacesWidescreen: 'Number of widescreen spaces',
  NumberOfTabs: 'Number Of tabs',
  NumberOfTemplatesGroupShared: 'Number of group-shared templates',
  NumberOfTemplatesPrivate: 'Number of private templates',
  NumberOfTemplatesPublic: 'Number of public templates',
  NumberOfTemplatesRoleShared: 'Number of role-shared templates',
  NumberOfTemplatesUserShared: 'Number of user-shared templates',
  NumberOfTemplates: 'Number of templates',
  NumberOfTradingLayoutGroups: 'Number of trading layout groups',
  NumberOfTradingLayoutPanels: 'Number of trading layout panels',
  NumberOfTradingLayoutPopouts: 'Number of trading layout popouts',
  NumberOfTradingLayouts: 'Number of trading layouts',
  NumberOfTradingSpaces: 'Number of trading spaces',
  NumberOfOpenPriceGrids: 'Number of open Price Grids',
  NumberOfOpenMultilegPriceGrids: 'Number of open Multileg Price Grids',
  TemplatesCountScope: 'Templates count scope',
  MarketSelectorShowAll: 'Market Selector Show All',
  Organization: 'organization',
  Release: 'Release',
  ResetOrderAccountsOnSubAccountChange: 'Select Market Accounts based on Sub Account',
  ShowAllInPrices: 'Show AllIn prices',
  ShowSidebarLabels: 'Show Sidebar Labels',
  ShowWatchlist: 'Show Watchlist',
  UseSubaccounts: 'Use subaccounts',
  UseTradeAllocations: 'Use trade allocations',
  Version: 'Version',
} as const;
export type MixpanelMetadata = (typeof MixpanelMetadata)[keyof typeof MixpanelMetadata];

export const MixpanelEventProperty = {
  Aggregation: 'Aggregation',
  AutoBatchingEnabled: 'autoBatchingEnabled',
  Amount: 'amount',
  App: 'app',
  Availability: 'availability',
  Blotter: 'blotter',
  CardType: 'cardType',
  ConfigKey: 'configKey',
  Checked: 'checked',
  Column: 'column',
  ColumnIndex: 'columnIndex',
  Columns: 'columns',
  Count: 'count',
  Comment: 'comment',
  Currency: 'currency',
  DeviceType: 'Device type',
  Direction: 'direction',
  DisplayMode: 'Display mode',
  Enabled: 'enabled',
  Existing: 'Existing',
  Expanded: 'expanded',
  Filter: 'filter',
  FromIndex: 'fromIndex',
  Group: 'group',
  Height: 'height',
  Hide: 'Hide',
  ID: 'ID',
  IncludesComment: 'includesComment',
  InstructionCount: 'instructionCount',
  Intent: 'intent',
  IsMultileg: 'isMultileg',
  IsMonitoringUser: 'isMonitoringUser',
  Layout: 'layout',
  LayoutSection: 'layoutSection',
  Locale: 'locale',
  Method: 'Method',
  Minimized: 'minimized',
  OpenedFrom: 'openedFrom',
  PanelType: 'Panel type',
  Path: 'path',
  Provider: 'provider',
  Perspective: 'Perspective',
  Pinned: 'pinned',
  ProductType: 'productType',
  Retry: 'retry',
  Section: 'section',
  Status: 'status',
  ShareType: 'shareType',
  Side: 'side',
  Size: 'size',
  SortMode: 'Sort mode',
  SortDirection: 'Sort direction',
  Source: 'source',
  Step: 'step',
  SubAccount: 'SubAccount',
  Strategy: 'strategy',
  TabIndex: 'tabIndex',
  TabLabel: 'tabLabel',
  TabLength: 'tabLength',
  TabType: 'tabType',
  Tag: 'tag',
  Template: 'template',
  Title: 'Title',
  ToIndex: 'toIndex',
  Tour: 'Tour',
  Type: 'type',
  Value: 'value',
  View: 'view',
  WindowHeight: 'windowHeight',
  WindowWidth: 'windowWidth',
} as const;
export type MixpanelEventProperty = (typeof MixpanelEventProperty)[keyof typeof MixpanelEventProperty];

/** MixpanelEventSource provides a context for the {@link MixpanelEvent} tracking events */
export const MixpanelEventSource = {
  AccountLedgerEventsDetails: 'Account Ledger Events Details',
  AllocationsBlotter: 'Allocations Blotter',
  AdminCounterparties: 'Admin Counterparties',
  AnalyticsDailyOverviewReport: 'Analytics daily overview report',
  AnalyticsDrawer: 'Analytics Drawer',
  AnalyticsMarketDetailsReport: 'Analytics market details report',
  AnalyticsMarketsOverviewReport: 'Analytics market overview report',
  AnalyticsModal: 'Analytics Modal',
  AnalyticsMonthlyOverviewReport: 'Analytics monthly overview report',
  AnalyticsStrategiesOverviewReport: 'Analytics strategy overview report',
  AnalyticsStrategyDetailsReport: 'Analytics strategy details report',
  AnalyticsSymbolDetailsReport: 'Analytics symbol details report',
  AnalyticsSymbolsOverviewReport: 'Analytics symbol overview report',
  AppLayoutEmptyError: 'App layout empty error',
  AppNotificationsDestinations: 'App Notifications Destinations Admin',
  AppNotificationsInbox: 'App Notifications Inbox',
  AppNotificationsRuleManagement: 'App Notifications Org Admin Settings',
  AppNotificationsUserSettings: 'App Notifications User Settings',
  BalancesBlotter: 'Balances Blotter',
  BidOfferButtons: 'Bid/Offer buttons',
  BuyingPowerBlotter: 'Buying Power Blotter',
  CancelOrderDialog: 'CancelOrderDialog',
  CandleSticks: 'CandleSticks',
  CareExecutionReportsBlotter: 'Care Execution Reports Blotter',
  CareOrderBlotter: 'Care Order Blotter',
  CareOrderForm: 'CareOrderForm',
  CareOrders: 'Care Orders',
  Credentials: 'Credentials',
  CreditBlotter: 'Credit Blotter',
  CustomerExecutionReportsBlotter: 'CustomerExecutionReportsBlotter',
  CustomerOrdersBlotter: 'CustomerOrdersBlotter',
  CustomerPriceGrid: 'Customer price grid',
  CustomerQuotesBlotter: 'CustomerQuotesBlotter',
  CustomerSettlementDrawer: 'Customer Settlement Drawer',
  CustomerTradesBlotter: 'CustomerTradesBlotter',
  CounterpartyMonitoring: 'Counterparty Monitoring',
  DDHOrders: 'DDH Orders',
  DealCashflows: 'Deal Cashflows',
  DealProductBuilder: 'Deal Product Builder',
  DealerMonitoring: 'Dealer Monitoring',
  DeepDive: 'Deepdive',
  DetailsDrawer: 'Details drawer',
  EditLayoutControls: 'Edit layout controls',
  ExecutionReportsBlotter: 'ExecutionReportsBlotter',
  FeatureShowcase: 'Feature Showcase',
  ForcedDesktopBanner: 'Forced desktop banner',
  Header: 'Header',
  HistoricalPriceChart: 'Historical price chart',
  FilledPercentModal: 'Filled % Modal',
  KeyboardShortcut: 'Keyboard shortcut',
  LayoutMenu: 'Layout menu',
  LoanBook: 'Loanbook',
  LoansBlotter: 'Loans Blotter',
  ReposBlotter: 'Repos Blotter',
  LoanDetails: 'Loan details',
  ManualPricingForm: 'Manual pricing form',
  ManualDealBookingForm: 'Manual Deal Booking Form',
  ManualRFQPricing: 'Manual RFQ Pricing',
  ManualRFQs: 'Manual RFQs',
  MarketAccountSelector: 'Market Account Selector',
  MarketCard: 'Market Card',
  MarketDataCards: 'Market data cards',
  MarketCardHeader: 'Market Card Header',
  PredictionMarketCard: 'Prediction Market Card',
  MarketExecutionReportsBlotter: 'MarketExecutionReportsBlotter',
  MarketOrdersBlotter: 'MarketOrdersBlotter',
  MarketQuotesBlotter: 'MarketQuotesBlotter',
  MarketsPanel: 'Markets Panel',
  MarketsTab: 'Markets tab',
  MarketTradesBlotter: 'MarketTradesBlotter',
  MobileNavMenu: 'Mobile nav menu',
  MobileTabBar: 'Mobile tab bar',
  MonitoringBlotterPanel: 'Monitoring Blotter Panel',
  MonitoringCustomerExecutionReportsBlotter: 'Monitoring Customer Execution Reports Blotter',
  MonitoringCustomerOrdersBlotter: 'Monitoring Customer Orders Blotter',
  MonitoringCustomerQuotesBlotter: 'Monitoring Customer Quotes Blotter',
  MonitoringCustomerTradesBlotter: 'Monitoring Customer Trades Blotter',
  MonitoringExecutionReportsBlotter: 'Monitoring Execution Reports Blotter',
  MonitoringMarketCashEventsBlotter: 'Monitoring Market Cash Transactions Blotter',
  MonitoringMarketExecutionReportsBlotter: 'Monitoring Market Execution Reports Blotter',
  MonitoringMarketOrdersBlotter: 'Monitoring Market Orders Blotter',
  MonitoringMarketQuotesBlotter: 'Monitoring Market Quotes Blotter',
  MonitoringMarketTradesBlotter: 'Monitoring Market Trades Blotter',
  MonitoringNotificationsBlotter: 'Monitoring Notifications Blotter',
  MonitoringOrdersBlotter: 'Monitoring Orders Blotter',
  MonitoringQuotesBlotter: 'Monitoring Quotes Blotter',
  MonitoringIndexBlotter: 'Monitoring Index Blotter',
  MonitoringIndexMarkBlotter: 'Monitoring Index Mark Blotter',
  MonitoringTradesBlotter: 'Monitoring Trades Blotter',
  MultilegComboScreen: 'Multileg Combo Screen',
  MultilegDeepDive: 'Multileg deep dive',
  MultilegModal: 'Multileg Modal',
  MultilegOrderBook: 'Multileg order book',
  MultilegPriceGrid: 'Multileg price grid',
  MultilegSecurityMaster: 'Multileg security master',
  NotificationsRuleManagement: 'Notifications Rule Management',
  NavigationSidebar: 'Navigation sidebar',
  NavigationSidebarSubNavItem: 'Navigation sidebar sub nav item',
  OMS: 'OMS',
  OTCDerivativesBlotter: 'OTC Derivatives Blotter',
  Options: 'Options',
  OptionsChain: 'Options chain',
  OrderAnalytic: 'Order Analytic',
  OrderBook: 'Order book',
  OrderCard: 'Order card',
  OrderDetails: 'Order Details',
  OrderDetailsAllocationsTab: 'Order Details Allocations Tab',
  OrderDetailsExecutionReportsTab: 'Order Details Execution Reports Tab',
  OrderDetailsMarketExecutionReportsTab: 'Order Details Market Execution Reports Tab',
  OrderDetailsMarketOrdersTab: 'Order Details Market Orders Tab',
  OrderDetailsTradesTab: 'Order Details Trades Tab',
  OrderForm: 'Order form',
  OrdersBlotter: 'Orders blotter',
  OrdersMonitoringPanel: 'Orders Monitoring Panel',
  PageHeader: 'Page header',
  Portfolio: 'Portfolio',
  // replace after PMS fully releases
  PortfolioAddresses: 'Portfolio Addresses (a.k.a Settings->Address Defaults)',
  PortfolioCreditAndSettlement: 'Portfolio Credit And Settlement',
  PortfolioPerformance: 'Portfolio Performance',
  PortfolioRecon: 'Portfolio Recon',
  // replace after PMS fully releases
  PortfolioSettlement: 'Portfolio Settlement (a.k.a. Dealer->Client Settlement)',
  PortfolioDashboard: 'Portfolio Dashboard',
  // Start of Portfolio Management sources
  PortfolioLpSettlement: 'Portfolio LP Settlement',
  PortfolioManagementOverview: 'Portfolio Management Overview',
  PortfolioManagementMargin: 'Portfolio Management Margin',
  PortfolioManagementPerformance: 'Portfolio Management Performance',
  PortfolioManagementTransactions: 'Portfolio Management Transactions',
  PortfolioManagementReports: 'Portfolio Management Reports',
  PortfolioRiskExposures: 'Portfolio Risk Exposures',
  PortfolioOperationsOverview: 'Portfolio Operations Overview',
  PortfolioOperationsTransactions: 'Portfolio Operations Transactions',
  PortfolioOperationsSettlement: 'Portfolio Operations Settlement',
  PortfolioOperationsReconciliation: 'Portfolio Operations Reconciliation',
  PortfolioOperationsReports: 'Portfolio Operations Reports',
  // End of Portfolio Management sources
  PositionAutoHedging: 'Position Autohedging',
  PositionAutoHedgingBlotter: 'Position AutoHedging Blotter',
  PositionAutoHedgingDrawer: 'Position AutoHedging Drawer',
  PositionAutoHedgingMiniBlotter: 'Position AutoHedging Mini Blotter',
  PositionAutohedgingRules: 'Position autohedging rules',
  PositionsBlotter: 'Positions Blotter',
  SubAccountPositionsBlotter: 'Sub Account Positions Blotter',
  UnifiedPositionsBlotter: 'Unified Positions Blotter',
  PowerSearch: 'PowerSearch',
  PreTrade: 'Pre-Trade',
  PreTradeHistory: 'Pre-Trade History',
  PreTradeScenarioDetails: 'Pre-Trade Scenario Details',
  PreTradeScenarios: 'Pre-Trade Scenarios',
  PreTradeTotalCostRiskTooltip: 'Pre-Trade Total Cost and Risk Tooltip',
  PredictionMarketsPriceGrid: 'Prediction Markets Price Grid',
  PriceGrid: 'Price Grid',
  PriceLadder: 'Price ladder',
  QuotesBlotter: 'Quotes Blotter',
  ReconMismatchesBlotter: 'Recon Mismatches Blotter',
  ReconMismatchesDetails: 'Recon Mismatches Details',
  ReconMismatchesDetailsResolveAllButton: 'Recon Mismatches Details Resolve All Button',
  ReconMismatchesDetailsResolveOneButton: 'Recon Mismatches Details Resolve One Button',
  ReconMismatchesResolutionDrawer: 'Recon Mismatches Resolution Drawer',
  RfqCard: 'RFQ card',
  RfqForm: 'RFQ form',
  RfqQuote: 'RFQ quote',
  RfqTradeBest: 'RFQ trade best',
  SalesOrderForm: 'Sales order form',
  SalesRfqCard: 'Sales RFQ Card',
  SalesRfqForm: 'Sales RFQ form',
  SecurityMaster: 'Security Master',
  SubAccountRollups: 'SubAccount Rollups',
  SubAccounts: 'SubAccounts',
  SymbolQuickList: 'Symbol Quick List',
  SymbolSelector: 'Symbol Selector',
  TakerQuoteBreakdown: 'Taker Quote Breakdown',
  TalosAdminConfigurations: 'Talos Admin Configurations',
  TopOfBook: 'Top of Book',
  TradeAllocationsBlotter: 'Trade Allocations Blotter',
  TradesBlotter: 'Trades blotter',
  TradingAggregations: 'Trading Aggregations',
  TradingControls: 'Trading Controls',
  TradingLimits: 'Trading Limits',
  UnifiedLiquidity: 'Unified Liquidity',
  TransferBlotter: 'Transfers Blotter',
  TreasuryBlotter: 'Treasury blotter',
  TreasuryManagement: 'Treasury Management',
  Users: 'Users',
  ApiKey: 'API Key',
  UserNotifications: 'User Notifications',
  VolumeLadder: 'Volume ladder',
  Watchlist: 'Watchlist',
} as const;
export type MixpanelEventSource = (typeof MixpanelEventSource)[keyof typeof MixpanelEventSource];
